import './App.css';
import Landing from './Landing';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
  useNavigate,
} from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './i18n';

function App() {
  const LanguageLayout = ({ children }) => {
    const { lang } = useParams();
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const [ready, setReady] = useState(false);

    useEffect(() => {
      const supportedLangs = ['en', 'lv'];
      const currentLang = lang || 'en';

      if (
        window.location.pathname.endsWith('/') &&
        window.location.pathname.length > 1
      ) {
        navigate(window.location.pathname.slice(0, -1), { replace: true });
        return;
      }

      if (!supportedLangs.includes(currentLang)) {
        navigate('/en', { replace: true });
        return;
      }

      i18n.changeLanguage(currentLang).then(() => setReady(true));
    }, [lang, i18n, navigate]);

    if (!ready) return null;

    return children;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/en" replace />} />
        <Route
          path=":lang"
          element={
            <LanguageLayout>
              <Landing />
            </LanguageLayout>
          }
        />
        <Route path="*" element={<Navigate to="/en" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
